import { render, staticRenderFns } from "./CrawledDocumentsFilterSection.vue?vue&type=template&id=22e7c9af&scoped=true"
import script from "./CrawledDocumentsFilterSection.vue?vue&type=script&lang=js"
export * from "./CrawledDocumentsFilterSection.vue?vue&type=script&lang=js"
import style0 from "./CrawledDocumentsFilterSection.vue?vue&type=style&index=0&id=22e7c9af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e7c9af",
  null
  
)

export default component.exports